module.exports = __webpack_public_path__ + "img/opslag-gamma.652064c9.svg";